import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '@/graphql/queries';
import * as queries_custom from '@/graphql/queries_custom';

export default {
  methods: {
    /**
     * @description
     * https://zeamster.atlassian.net/browse/ATLAS-1371
     * <Autocomplete feature> Case ->Task Page
     * 
     * @param {String} searchTerm
     * @returns {Void}
     */
    onSearch(searchTerm) {
      // lazy load not enabled - bail
      if (this.field.isLazyLoadEnabled !== true) {
        return this.field.change(searchTerm);
      }
      
      // no search term - empty result set and bail
      if (!searchTerm || !searchTerm.trim().length) {
        //clear search value
        this.field.setVal("");
        this.field.searchTerm = "";
        return new Promise(resolve => resolve([]));
      }
      
      // clear existing timeout and set up new lookup
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.lookup(searchTerm.trim());
      }, 250);
    },
    /**
     * @description
     * Search AppSync and get related records
     * 
     * @param {String} searchTerm
     * @returns {Void}
     */
    lookup(searchTerm) {
      const {
        lazyLoadListQueryId,
        lazyLoadResponseFieldName,
        lazyLoadCallback,
      } = this.field;
      
      let query = queries[lazyLoadListQueryId];
      if (typeof query === 'undefined') {
        query = queries_custom[lazyLoadListQueryId];
      }
      
      // graphql operation
      const operation = graphqlOperation(query, {
        filter: this.getElasticSearchFilter(searchTerm),
        limit: this.field.lazyLoadLimit || 49,
      });
      
      // call API
      API.graphql(operation)
        .then(res => {
          // get items
          const items = this.$reduce(res, `data.${lazyLoadResponseFieldName}.items`);
          
          // call format response callback if provided else return items
          if (typeof lazyLoadCallback === 'function') {
            this.$set(this.field, 'options', lazyLoadCallback(items));
          } else {
            this.$set(this.field, 'options', new Promise(resolve => resolve(items)));
          }
        })
        .catch(err => {
          return new Promise(resolve => resolve([]));
        });
    },
    /**
     * @description
     * Get Elasticsearch esQuery filter for all lazyLoadSearchableFields
     * 
     * @param {String} searchTerm
     * @returns {String}
     */
    getElasticSearchFilter(searchTerm) {
      const columnFilters = this.field.lazyLoadSearchableFields.map(_fieldName => ({
        query_string: {
          default_field: _fieldName,
          query: `*${searchTerm}*`,
        },
      }));
      //add filter passed from list config
      let _filter = null;
      if (this.field.lazyLoadFilter) {
        _filter = this.field.lazyLoadFilter;
      }
      const filter = {
        bool: {
          should: columnFilters,
          minimum_should_match: 1,
        }
      };
      if (_filter) {
        filter.bool.filter = _filter;
      }
      return { esQuery: JSON.stringify(filter) };
    },
  }
};
